module.exports = __webpack_public_path__ + "static/media/img4.7103843e.jpg";